module.exports = __webpack_public_path__ + "static/media/operation-white.e714b767.svg";